'use client';

import { useTranslation } from 'react-i18next';

import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';

export default function AboutUsButton() {
  const { t } = useTranslation('common');
  const open = useModalsStore.use.open();

  return (
    <button onClick={() => open(Modals.AboutUs)}>
      {t('footer.menu.aboutUs')}
    </button>
  );
}
